module.exports = __webpack_public_path__ + "static/img/匕首.9119a3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/匕首.png
// module id = YVnn
// module chunks = 4